// extracted by mini-css-extract-plugin
export var bold = "_yd-0";